export const LabelPrintScenarioItemsPluginSettings: IPluginSettings = {
    name: 'Позиции',
    mnemocode: 'label_print_scenario_items_plugin',
    permission: 'LabelDesigner',
    columns: [{
        order: 0,
        propertyName: 'name',
        propertyType: 'string',
        displayName: 'Наименование',
        visibility: true,
        width: 400
    },
    {
        order: 1,
        propertyName: 'contractorName',
        propertyType: 'string',
        displayName: 'Контрагент',
        visibility: true,
        width: 400
    }]
}
